export default "__VITE_ASSET__BkIsGBmH__"